<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'vehicle-alarm'"
      v-bind="observer"
      :validated="formObserver.validated && observer.failed"
    >
      <form-row
        :label="isAdditional ? titleAdditional || title : title"
        :question="isAdditional ? subtitleAdditional || subtitle : subtitle"
        :help-text="helpText || 'You can find this information in your vehicle handbook. If you have a Thatcham approved security device fitted, many insurance providers may require a certificate of installation.'"
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ failed }"
          :name="questionId"
          :vid="`${stepId}_${questionId}`"
          rules="required"
        >
          <radio
            v-model="vehicleAlarmModel"
            :name="`${stepId}-${questionId}`"
            :items="constants.YES_NO"
            :error="failed"
            :data-test="snakeCase(questionFields.vehicleAlarm)"
          />
        </validation-provider>
      </form-row>
      <form-row
        v-if="vehicleAlarmModel"
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_${questionId}`"
          :name="questionId"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.vehicleAlarm"
            :items="vehicleAlarmOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select alarm / immobiliser', isMobile)"
            :data-test="`${snakeCase(questionFields.vehicleAlarm)}_type`"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import { omit } from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-vehicle-alarm',
  extends: QuestionBase,
  data () {
    return {
      fields: ['vehicleAlarm'],
    };
  },
  computed: {
    vehicleAlarmModel: {
      get () {
        const current = this.questionData.vehicleAlarm;
        if (current === null) return null;
        if (current === 'N') return false;
        return true;
      },
      set (val) {
        this.questionData.vehicleAlarm = val ? '' : 'N';
      },
    },
    vehicleAlarmOptions () {
      return this.helpers.createOptions({ source: omit(this.constants.VEHICLE_ALARM_IMMOBILISER, ['N']) });
    },
  },
};
</script>
